export default [
    {
        path: '/orders',
        name: 'Company / Orders',
        component: () => import('@/views/pages/orders'),
        meta:
        {
            page: 'list',
        },
        children:
        [
            {
                path: 'overview',
                name: 'Company / Order Overview',
                component: () => import('@/views/pages/orders'),
                meta:
                {
                    page: 'overview',
                    subPage: 'main',
                },
            },
            {
                path: ':code',
                name: 'Company / View Order',
                component: () => import('@/views/pages/orders'),
                meta:
                {
                    page: 'view',
                },
            },
        ],
    },
];